import {FC, Fragment, ReactElement, useEffect} from 'react';
import Box from '@material-ui/core/Box';
import {makeStyles} from '@material-ui/core/styles';
import {observer} from 'mobx-react-lite';
import {Grid} from '@material-ui/core';

interface CategoryCardProps {
    title: string;
    setCategory: (entry: string) => void;
    index: number;
    children: any;
}

const useStyles = makeStyles({
    sectionTitleWrapper: {
        display: 'flex',
        alignItems: 'center',
        textTransform: 'capitalize',
        marginBottom: 24,
    },
    sectionTitle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 46,
        width: 46,
        borderRadius: '50%',
        backgroundColor: '#E9ECFF',
        color: '#3F51B5',
        marginRight: 21,
        fontSize: 26,
        textAlign: 'center',
    },
});

function SectionTitle(props: {index: number; children: any}) {
    const classes = useStyles();
    const {index, children} = props;
    return (
        <div className={classes.sectionTitleWrapper}>
            <span className={classes.sectionTitle}>{index}</span>
            {children}
        </div>
    );
}

export const CategoryCard: FC<CategoryCardProps> = observer(({title, setCategory, index, children}) => {
    const options = {
        root: document.querySelector('#tab2'),
        rootMargin: '0px',
        threshold: 0.4,
    };

    const callback = (entries: IntersectionObserverEntry[]) => {
        entries.forEach((entry) => entry.isIntersecting && setCategory(entry?.target?.id));
    };

    const intersectionObserver = new IntersectionObserver(callback, options);

    useEffect(() => {
        const id = `${title.replaceAll(/ |&/g, '_')}_${index}`;
        const target = document.getElementById(id);

        if (target) {
            intersectionObserver.observe(target);
        }

        return () => {
            intersectionObserver.unobserve(target as Element);
        };
    }, []);

    return (
        <Fragment>
            <div id={`${title.replaceAll(/ |&/g, '_')}_${index}_header`} style={{position: 'relative', top: -250}} />
            <Box
                id={`${title.replaceAll(/ |&/g, '_')}_${index}`}
                style={{
                    padding: 20,
                    marginBottom: 20,
                }}
            >
                <SectionTitle index={index}>
                    <strong>{title}</strong>
                </SectionTitle>
                <Grid container spacing={3}>
                    {children}
                </Grid>
            </Box>
        </Fragment>
    );
});
